<template>
  <div>
    <b-modal
      id="modal-picture"
      size="lg"
      ok-title="Save"
      cancel-title="Cancel"
      hide-header
      no-close-on-backdrop
    >
      <div class="d-flex">
        <h5 @click="close()" class="ms-auto" style="font-size: 1.5rem">x</h5>
      </div>
      <img
        v-if="picture && picture.file_url"
        :src="picture.file_url"
        class="w-100"
      />
      <template #modal-footer="{ close }">
        <button class="btn button-outline-green px-5" @click="close()">
          {{ $t("TXT_CLOSE") }}
        </button>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  props: ["picture"],
  methods: {
    close() {
      this.$bvModal.hide("modal-picture");
    },
  },
};
</script>
